import { render } from "./TaxReportCustom2024.vue?vue&type=template&id=1ce3131e&scoped=true"
import script from "./TaxReportCustom2024.vue?vue&type=script&lang=js"
export * from "./TaxReportCustom2024.vue?vue&type=script&lang=js"

import "./TaxReportCustom2024.vue?vue&type=style&index=0&id=1ce3131e&scoped=true&lang=css"
import "./TaxReportCustom2024.vue?vue&type=style&index=1&id=1ce3131e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce3131e"]])

export default __exports__